import React,{useState} from "react";
import {Modal,Row,Col,Button} from "react-bootstrap";

function CompanyInformation({show,handleClose}){

const [company,setCompany]=useState("");
const [designation,setDesignation]=useState("");
const [startDate,setStartDate]=useState("");
const [endDate,setEndDate]=useState("");
const [present,setPresent]=useState(true);

const handleSave=()=>{
console.log({
company,
designation,
startDate,
endDate,
present
});
handleClose();
};

return(

<Modal show={show} onHide={handleClose} centered size="xl">

<div style={{
background:"#fff",
borderRadius:"8px",
overflow:"hidden"
}}>

{/* Header */}
<div style={{
display:"flex",
justifyContent:"space-between",
padding:"22px 24px",
borderBottom:"1px solid #dbe2ea"
}}>

<h3 style={{margin:0}}>
Company Information
</h3>

<button
onClick={handleClose}
style={{
border:"none",
background:"#6b7280",
color:"#fff",
width:"30px",
height:"30px",
borderRadius:"50%"
}}
>
✕
</button>

</div>


{/* Form */}
<div style={{padding:"28px 24px"}}>

<Row>

<Col md={6}>
<label>Previous Company Name *</label>

<input
value={company}
onChange={(e)=>setCompany(e.target.value)}
className="form-control mt-2 mb-4"
/>
</Col>


<Col md={6}>
<label>Designation *</label>

<input
value={designation}
onChange={(e)=>setDesignation(e.target.value)}
className="form-control mt-2 mb-4"
/>
</Col>


<Col md={6}>
<label>Start Date *</label>

<input
type="date"
value={startDate}
onChange={(e)=>setStartDate(e.target.value)}
className="form-control mt-2"
/>
</Col>


<Col md={6}>
<label>End Date *</label>

<input
type="date"
disabled={present}
value={endDate}
onChange={(e)=>setEndDate(e.target.value)}
className="form-control mt-2"
/>
</Col>

</Row>


<div style={{marginTop:"22px"}}>

<label>
<input
type="checkbox"
checked={present}
onChange={(e)=>setPresent(e.target.checked)}
/>

<span style={{marginLeft:"10px"}}>
Check if you working present
</span>

</label>

</div>

</div>


{/* Footer */}
<div style={{
borderTop:"1px solid #dbe2ea",
padding:"16px 24px",
display:"flex",
justifyContent:"flex-end",
gap:"12px"
}}>

<Button
variant="light"
onClick={handleClose}
>
Cancel
</Button>

<Button
onClick={handleSave}
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</div>

</div>

</Modal>

);
}

export default CompanyInformation;